import { filterBy } from '@progress/kendo-data-query';
import { Button } from '@progress/kendo-react-buttons';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import { FormDatePicker, FormInput, FormMultiSelect, FormTextArea } from 'commons/forms/form';
import ConfirmationModal from 'commons/modal/ConfirmationModal';
import { number } from 'prop-types';
import React, { useState } from 'react';
import '../banner.scss';

export default function BannerItemRmv(props) {
  const { src, href, priority, from, to, objectID, query, deleteExist, update, categories } = props;
  const [confirmationDeleteModalVisible, setConfirmationDeleteModalVisible] = useState(false);
  const [disableReadOnly, setDisableReadOnly] = useState(true);
  const [categoriesList, setCategoriesList] = useState(categories);
  const [acceptedChanges, setAcceptedChanges] = useState(true)

  return (
    <>
      {confirmationDeleteModalVisible && (
        <ConfirmationModal
          text={`Supprimer ?`}
          onClose={() => {
            setConfirmationDeleteModalVisible(false);
          }}
          onConfirm={() => {
            setConfirmationDeleteModalVisible(false);
            deleteExist(objectID);
          }}
        />
      )}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Form
          onSubmit={update}
          initialValues={{
            clickHref: href,
            priority: priority,
            path: src,
            objectID: objectID,
            categories: query,
            dateLimite: typeof to == 'number' ? new Date(to * 1000) : new Date(new Date().setHours(0, 0, 0, 0)),
            dateDebut: typeof from == 'number' ? new Date(from * 1000) : new Date(new Date().setHours(0, 0, 0, 0)),
          }}
          render={(formRenderProps) => (
            <FormElement>
              <fieldset
                className={'k-form-fieldset'}
                style={{ padding: '1rem' }}
              >
                <div className="row">
                  <div className="col-md-6">
                    <img
                      style={{
                        height: '23rem',
                        margin: 'auto',
                        display: 'block',
                      }}
                      loading="lazy"
                      alt={src}
                      src={src}
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-12">
                        <Field
                          id={'clickHref'}
                          name={'clickHref'}
                          label={'Référence click'}
                          component={FormInput}
                          onChange={() =>
                            setAcceptedChanges(false)
                          }
                          style={{ color: 'black' }}
                          wrapperStyle={{
                            marginRight: '18px',
                          }}
                          disabled={disableReadOnly}
                        />
                        <Field
                          type={"number"}
                          id={'priority'}
                          name={'priority'}
                          label={'Priorité'}
                          component={FormInput}
                          onChange={() =>
                            setAcceptedChanges(false)
                          }
                          wrapperStyle={{
                            marginRight: '18px',
                          }}
                          disabled={disableReadOnly}
                        />
                        {disableReadOnly && (
                          <Field
                            id={'categories'}
                            name={'categories'}
                            label={'Catégories'}
                            component={FormTextArea}
                            wrapperStyle={{
                              marginRight: '18px',
                            }}
                            disabled={true}
                          />
                        )}
                        {!disableReadOnly && (
                          <Field
                            id={'categories'}
                            name={'categories'}
                            label={'Catégories'}
                            onChange={() =>
                              setAcceptedChanges(false)
                            }
                            component={FormMultiSelect}
                            optional={false}
                            filterable={true}
                            data={categoriesList}
                            onFilterChange={(e) => {
                              setCategoriesList(
                                filterBy(categories.slice(), e.filter)
                              );
                            }}
                            wrapperStyle={{
                              marginRight: '18px',
                            }}
                          />
                        )}
                        <Field
                          id={'dateDebut'}
                          name={'dateDebut'}
                          label={'Date début'}
                          onChange={() =>
                            setAcceptedChanges(false)
                          }
                          component={FormDatePicker}
                          wrapperStyle={{
                            minWidth: '10rem',
                            width: '12%',
                            marginRight: '15px',
                          }}
                          disabled={disableReadOnly}
                        />
                        <Field
                          id={'dateLimite'}
                          name={'dateLimite'}
                          label={'Date limite'}
                          onChange={() =>
                            setAcceptedChanges(false)
                          }
                          component={FormDatePicker}
                          disabled={disableReadOnly}
                          wrapperStyle={{
                            minWidth: '10rem',
                            width: '12%',
                            marginRight: '15px',
                          }}
                        />
                        <div className="k-form-buttons">
                          {disableReadOnly && (
                            <Button
                              onClick={() =>
                                setDisableReadOnly(false)
                              }
                              style={{
                                background: "#2596be"
                              }}
                            >
                              Modifier
                            </Button>
                          )}
                          {!disableReadOnly && (
                            <Button
                              disabled={acceptedChanges}
                              type='submit'
                              style={{
                                background: "#009900"
                              }}
                            >
                              Accepter
                            </Button>
                          )}
                          {!disableReadOnly && (
                            <Button
                              onClick={() =>
                                setDisableReadOnly(true)
                              }
                            >
                              Annuler
                            </Button>
                          )}
                          {disableReadOnly && (
                            <Button
                              onClick={() =>
                                setConfirmationDeleteModalVisible(true)
                              }
                            >
                              Supprimer
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </FormElement>
          )}
        />
        <div
          style={{
            height: '1px',
            backgroundColor: 'lightgray',
            margin: '25px 0 5px 0',
          }}
        ></div>
      </div>
    </>
  );
}
